import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Door from "./pages/Door";
import HomeVision from "./pages/HomeVision";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/door/:id" element={<Door />} />
          <Route path="/homevision" element={<HomeVision />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
